module.exports = __webpack_public_path__ + "img/Yanlei_Diao.ff6e1721.png";